/* eslint-disable no-shadow */
import gql from 'graphql-tag'
import api from '../apiClient'

export default {
  readPagosByIdFactura: _id =>
    api
      .send({
        query: gql`
          query readPagosByIdFactura($_id: ID!) {
            Pago {
              readPagosByIdFactura(_id: $_id) {
                _id
                fecha
                consecutivo
                monto
                estado
                concepto
                usuario
                cuentaContable
                medioPago {
                  id
                }
                detalle
                comentarios
                razonEliminar
                _idRecord

                createdAt
                updatedAt
              }
            }
          }
        `,
        variables: {
          _id
        }
      })
      .then(result => result.data.data.Pago.readPagosByIdFactura),

  readIngresosByEmisorbyDateRange: (emisor, filter, showNC) =>
    api
      .send({
        query: gql`
          query readIngresosByEmisorbyDateRange($emisor: ID!, $filter: FilterVentas, $showNC: Boolean) {
            Pago {
              readIngresosByEmisorbyDateRange(emisor: $emisor, filter: $filter, showNC: $showNC) {
                _id
                documento {
                  value
                }
                fecha
                consecutivo
                monto
                estado
                concepto
                detalle
                usuario

                notaCredito

                consecutivoFactura
                cliente
                cuentaContable

                createdAt
                updatedAt
              }
            }
          }
        `,
        variables: {
          emisor,
          filter,
          showNC
        }
      })
      .then(result => result.data.data.Pago.readIngresosByEmisorbyDateRange),

  readBancosByEmisor: (emisor, filter) =>
    api
      .send({
        query: gql`
          query readBancosByEmisor($emisor: ID!, $filter: FilterVentas) {
            Pago {
              readBancosByEmisor(emisor: $emisor, filter: $filter) {
                ingresos
                egresos
              }
            }
          }
        `,
        variables: {
          emisor,
          filter
        }
      })
      .then(result => result.data.data.Pago.readBancosByEmisor),

  readEgresosByEmisorbyDateRange: (receptor, filter, showNC) =>
    api
      .send({
        query: gql`
          query readEgresosByEmisorbyDateRange($receptor: ID!, $filter: FilterVentas, $showNC: Boolean) {
            Pago {
              readEgresosByEmisorbyDateRange(receptor: $receptor, filter: $filter, showNC: $showNC) {
                _id
                fecha
                consecutivo
                original
                monto
                estado
                concepto
                detalle
                usuario

                notaCredito

                consecutivoFactura
                proveedor
                cuentaContable

                createdAt
                updatedAt
              }
            }
          }
        `,
        variables: {
          receptor,
          filter,
          showNC
        }
      })
      .then(result => result.data.data.Pago.readEgresosByEmisorbyDateRange),

  readCuentasCobrarByEmisorbyDateRange: (emisor, filter, showNC, showPagas, showRechazadas, showLineaDetalle) =>
    api
      .send({
        query: gql`
          query readCuentasCobrarByEmisorbyDateRange(
            $emisor: ID!
            $filter: FilterVentas
            $showNC: Boolean
            $showPagas: Boolean
            $showRechazadas: Boolean
            $showLineaDetalle: Boolean
          ) {
            Pago {
              readCuentasCobrarByEmisorbyDateRange(
                emisor: $emisor
                filter: $filter
                showNC: $showNC
                showPagas: $showPagas
                showRechazadas: $showRechazadas
                showLineaDetalle: $showLineaDetalle
              ) {
                _id
                _idFactura
                cliente
                consecutivo
                totalCredito
                totalPago
                saldo
                createdAt
                notaCredito

                documento
                estadoDocumento

                detalleServicio {
                  lineaDetalle {
                    numeroLinea
                    cantidad
                    detalle
                    montoTotalLinea
                  }
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          filter,
          showNC,
          showPagas,
          showRechazadas,
          showLineaDetalle
        }
      })
      .then(result => result.data.data.Pago.readCuentasCobrarByEmisorbyDateRange),

  readCuentasPagarByEmisorbyDateRange: (receptor, filter, showNC, showPagas) =>
    api
      .send({
        query: gql`
          query readCuentasPagarByEmisorbyDateRange($receptor: ID!, $filter: FilterVentas, $showNC: Boolean, $showPagas: Boolean) {
            Pago {
              readCuentasPagarByEmisorbyDateRange(receptor: $receptor, filter: $filter, showNC: $showNC, showPagas: $showPagas) {
                _id
                _idFactura
                proveedor
                consecutivo
                totalCredito
                totalPago
                saldo
                createdAt
                notaCredito
                fechaEmisionOriginal
                original
              }
            }
          }
        `,
        variables: {
          receptor,
          filter,
          showNC,
          showPagas
        }
      })
      .then(result => result.data.data.Pago.readCuentasPagarByEmisorbyDateRange),

  readPagosByEmisorbyDateRange: (emisor, filter, showNC, showPagas) =>
    api
      .send({
        query: gql`
          query readPagosByEmisorbyDateRange($emisor: ID!, $filter: FilterVentas, $showNC: Boolean, $showPagas: Boolean) {
            Pago {
              readPagosByEmisorbyDateRange(emisor: $emisor, filter: $filter, showNC: $showNC, showPagas: $showPagas) {
                _id
                fecha
                consecutivo
                monto
                estado
                concepto
                usuario

                consecutivoFactura
                cliente
                cuentaContable

                notaCredito

                createdAt
                updatedAt
              }
            }
          }
        `,
        variables: {
          emisor,
          filter,
          showNC,
          showPagas
        }
      })
      .then(result => result.data.data.Pago.readPagosByEmisorbyDateRange),

  readPagosComprasByEmisorbyDateRange: (receptor, filter, showNC, showPagas) =>
    api
      .send({
        query: gql`
          query readPagosComprasByEmisorbyDateRange($receptor: ID!, $filter: FilterVentas, $showNC: Boolean, $showPagas: Boolean) {
            Pago {
              readPagosComprasByEmisorbyDateRange(receptor: $receptor, filter: $filter, showNC: $showNC, showPagas: $showPagas) {
                _id
                fecha
                consecutivo
                monto
                estado
                concepto
                usuario

                consecutivoFactura
                proveedor
                cuentaContable

                notaCredito

                createdAt
                updatedAt
              }
            }
          }
        `,
        variables: {
          receptor,
          filter,
          showNC,
          showPagas
        }
      })
      .then(result => result.data.data.Pago.readPagosComprasByEmisorbyDateRange),

  readPagosByCliente: (cliente, showNC, showMoneda, isClient = true) =>
    api
      .send({
        query: gql`
          query readPagosByCliente($cliente: ID!, $showNC: Boolean, $showMoneda: Boolean, $isClient: Boolean) {
            Pago {
              readPagosByCliente(cliente: $cliente, showNC: $showNC, showMoneda: $showMoneda, isClient: $isClient) {
                _id
                factura {
                  _id
                }
                fecha
                fechaFactura
                consecutivo
                monto
                estado
                concepto

                consecutivoFactura
                notaCredito

                cuentaContable

                moneda {
                  codigoMoneda {
                    id
                    value
                    simbolo
                  }
                  tipoCambio
                }

                createdAt
                updatedAt
              }
            }
          }
        `,
        variables: {
          cliente,
          showNC,
          showMoneda,
          isClient
        }
      })
      .then(result => result.data.data.Pago.readPagosByCliente),

  readCreditoByCliente: (cliente, showNC, isClient = true) =>
    api
      .send({
        query: gql`
          query readCreditoByCliente($cliente: ID!, $showNC: Boolean, $isClient: Boolean) {
            Pago {
              readCreditoByCliente(cliente: $cliente, showNC: $showNC, isClient: $isClient) {
                feed {
                  _id
                  documento {
                    value
                  }
                  emisor {
                    cuentaContable
                  }
                  receptor {
                    cuentaContable
                  }
                  consecutivo
                  plazoCredito
                  createdAt
                  resumenFactura {
                    codigoTipoMoneda {
                      codigoMoneda {
                        id
                        value
                        simbolo
                      }
                      tipoCambio
                    }
                    totalComprobante
                  }
                  totalPago
                  saldo
                  notaCredito {
                    id
                  }
                }
              }
            }
          }
        `,
        variables: {
          cliente,
          showNC,
          isClient
        }
      })
      .then(result => result.data.data.Pago.readCreditoByCliente),

  readPagosClienteByEmisorbyDateRange: (emisor, filter, showPagas) =>
    api
      .send({
        query: gql`
          query readPagosClienteByEmisorbyDateRange($emisor: ID!, $filter: FilterVentas, $showPagas: Boolean) {
            Pago {
              readPagosClienteByEmisorbyDateRange(emisor: $emisor, filter: $filter, showPagas: $showPagas) {
                cliente
                cantidadFacturas
                totalCredito
                totalPago
                saldo
              }
            }
          }
        `,
        variables: {
          emisor,
          filter,
          showPagas
        }
      })
      .then(result => result.data.data.Pago.readPagosClienteByEmisorbyDateRange),

  readPagosProveedorByEmisorbyDateRange: (receptor, filter, showPagas) =>
    api
      .send({
        query: gql`
          query readPagosProveedorByEmisorbyDateRange($receptor: ID!, $filter: FilterVentas, $showPagas: Boolean) {
            Pago {
              readPagosProveedorByEmisorbyDateRange(receptor: $receptor, filter: $filter, showPagas: $showPagas) {
                proveedor
                cantidadFacturas
                totalCredito
                totalPago
                saldo
              }
            }
          }
        `,
        variables: {
          receptor,
          filter,
          showPagas
        }
      })
      .then(result => result.data.data.Pago.readPagosProveedorByEmisorbyDateRange),

  create: input =>
    api
      .send({
        query: gql`
          mutation create($input: PagoInput!) {
            Pago {
              create(input: $input) {
                _id
                consecutivo
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Pago.create),

  delete: (_idEmisor, _id, input) =>
    api
      .send({
        query: gql`
          mutation delete($_idEmisor: ID!, $_id: ID!, $input: [DeletePagoInput!]!) {
            Pago {
              delete(_idEmisor: $_idEmisor, _id: $_id, input: $input) {
                _id
                state
                message
              }
            }
          }
        `,
        variables: { _idEmisor, _id, input }
      })
      .then(result => result.data.data.Pago.delete),

  readPagosByEmisor: (emisor, cursor, limit = 10, filter = null) =>
    api
      .send({
        query: gql`
          query readPagosByEmisor($emisor: ID!, $cursor: String, $limit: Int, $filter: Filter) {
            Pago {
              readPagosByEmisor(emisor: $emisor, cursor: $cursor, limit: $limit, filter: $filter) {
                feed {
                  _id
                  usuario
                  mail
                  monto
                  fecha
                  createdAt
                  cliente
                  consecutivo
                  consecutivoFactura
                  estado
                  notaCredito
                  concepto
                  detalle
                  factura {
                    _id
                  }
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          cursor,
          limit,
          filter
        }
      })
      .then(result => result.data.data.Pago.readPagosByEmisor),

  readPagosComprasByEmisor: (emisor, cursor, limit = 10, filter = null) =>
    api
      .send({
        query: gql`
          query readPagosComprasByEmisor($emisor: ID!, $cursor: String, $limit: Int, $filter: Filter) {
            Pago {
              readPagosComprasByEmisor(emisor: $emisor, cursor: $cursor, limit: $limit, filter: $filter) {
                feed {
                  _id
                  usuario
                  mail
                  monto
                  fecha
                  createdAt
                  proveedor
                  consecutivo
                  consecutivoFactura
                  estado
                  notaCredito
                  concepto
                  detalle
                  factura {
                    _id
                  }
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          cursor,
          limit,
          filter
        }
      })
      .then(result => result.data.data.Pago.readPagosComprasByEmisor),

  readPagosVentasBySearchString: (emisor, searchString) =>
    api
      .send({
        query: gql`
          query readPagosVentasBySearchString($emisor: ID!, $searchString: String!) {
            Pago {
              readPagosVentasBySearchString(emisor: $emisor, searchString: $searchString) {
                feed {
                  _id
                  usuario
                  mail
                  monto
                  fecha
                  createdAt
                  cliente
                  consecutivo
                  consecutivoFactura
                  estado
                  notaCredito
                  concepto
                  detalle
                  factura {
                    _id
                  }
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          searchString
        }
      })
      .then(result => result.data.data.Pago.readPagosVentasBySearchString),

  readPagosComprasBySearchString: (emisor, searchString) =>
    api
      .send({
        query: gql`
          query readPagosComprasBySearchString($emisor: ID!, $searchString: String!) {
            Pago {
              readPagosComprasBySearchString(emisor: $emisor, searchString: $searchString) {
                feed {
                  _id
                  usuario
                  mail
                  monto
                  fecha
                  createdAt
                  proveedor
                  consecutivo
                  consecutivoFactura
                  estado
                  notaCredito
                  concepto
                  detalle
                  factura {
                    _id
                  }
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          searchString
        }
      })
      .then(result => result.data.data.Pago.readPagosComprasBySearchString),

  readPagosByDateRange: (emisor, inicio, final) =>
    api
      .send({
        query: gql`
          query readPagosByDateRange($emisor: ID!, $inicio: Date, $final: Date) {
            Pago {
              readPagosByDateRange(emisor: $emisor, inicio: $inicio, final: $final) {
                feed {
                  _id
                  usuario
                  mail
                  monto
                  fecha
                  createdAt
                  cliente
                  consecutivo
                  consecutivoFactura
                  estado
                  notaCredito
                  concepto
                  detalle
                  factura {
                    _id
                  }
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          inicio,
          final
        }
      })
      .then(result => result.data.data.Pago.readPagosByDateRange),

  readPagosComprasByDateRange: (emisor, inicio, final) =>
    api
      .send({
        query: gql`
          query readPagosComprasByDateRange($emisor: ID!, $inicio: Date, $final: Date) {
            Pago {
              readPagosComprasByDateRange(emisor: $emisor, inicio: $inicio, final: $final) {
                feed {
                  _id
                  usuario
                  mail
                  monto
                  fecha
                  createdAt
                  proveedor
                  consecutivo
                  consecutivoFactura
                  estado
                  notaCredito
                  concepto
                  detalle
                  factura {
                    _id
                  }
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          inicio,
          final
        }
      })
      .then(result => result.data.data.Pago.readPagosComprasByDateRange),

  readTotalDocumentos: emisor =>
    api
      .send({
        query: gql`
          query readTotalDocumentos($emisor: ID!) {
            Pago {
              readTotalDocumentos(emisor: $emisor)
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.Pago.readTotalDocumentos),

  readTotalDocumentosCompras: emisor =>
    api
      .send({
        query: gql`
          query readTotalDocumentosCompras($emisor: ID!) {
            Pago {
              readTotalDocumentosCompras(emisor: $emisor)
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.Pago.readTotalDocumentosCompras),

  readIngresosSinBancoByEmisorbyDateRange: (emisor, inicio, final) =>
    api
      .send({
        query: gql`
          query readIngresosSinBancoByEmisorbyDateRange($emisor: ID!, $inicio: Date, $final: Date) {
            Pago {
              readIngresosSinBancoByEmisorbyDateRange(emisor: $emisor, inicio: $inicio, final: $final) {
                feed {
                  _id
                  usuario
                  mail
                  monto
                  fecha
                  createdAt
                  cliente
                  consecutivo
                  consecutivoFactura
                  estado
                  notaCredito
                  concepto
                  detalle
                  factura {
                    _id
                  }
                }
                # pageInfo {
                #   nextPageCursor
                #   hasNextPage
                # }
              }
            }
          }
        `,
        variables: {
          emisor,
          inicio,
          final
        }
      })
      .then(result => result.data.data.Pago.readIngresosSinBancoByEmisorbyDateRange),

  readEgresosSinBancoByEmisorbyDateRange: (emisor, inicio, final) =>
    api
      .send({
        query: gql`
          query readEgresosSinBancoByEmisorbyDateRange($emisor: ID!, $inicio: Date, $final: Date) {
            Pago {
              readEgresosSinBancoByEmisorbyDateRange(emisor: $emisor, inicio: $inicio, final: $final) {
                feed {
                  _id
                  usuario
                  mail
                  monto
                  fecha
                  createdAt
                  cliente
                  consecutivo
                  consecutivoFactura
                  estado
                  notaCredito
                  concepto
                  detalle
                  factura {
                    _id
                  }
                }
                # pageInfo {
                #   nextPageCursor
                #   hasNextPage
                # }
              }
            }
          }
        `,
        variables: {
          emisor,
          inicio,
          final
        }
      })
      .then(result => result.data.data.Pago.readEgresosSinBancoByEmisorbyDateRange),

  // TODO: revisar con el flujo contable
  // mueveBancos: (cajaSesion, banco) =>
  //   api
  //     .send({
  //       query: gql`
  //         mutation mueveBancos($cajaSesion: ID!, $banco: AccountInput!) {
  //           Pago {
  //             mueveBancos(cajaSesion: $cajaSesion, banco: $banco)
  //           }
  //         }
  //       `,
  //       variables: { cajaSesion, banco }
  //     })
  //     .then(result => result.data.data.Pago.mueveBancos),

  readSaldoCliente: (_id, isFEC) =>
    api
      .send({
        query: gql`
          query readSaldoCliente($_id: ID!, $isFEC: Boolean) {
            Pago {
              readSaldoCliente(_id: $_id, isFEC: $isFEC) {
                simbolo
                totalPagado
                totalFacturas
                totalMonto
                saldo
              }
            }
          }
        `,
        variables: { _id, isFEC }
      })
      .then(result => result.data.data.Pago.readSaldoCliente)
}
